import { render, staticRenderFns } from "./AddSectionSidebar.vue?vue&type=template&id=524bfa00&scoped=true&"
import script from "./AddSectionSidebar.vue?vue&type=script&lang=js&"
export * from "./AddSectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddSectionSidebar.vue?vue&type=style&index=0&id=524bfa00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bfa00",
  null
  
)

export default component.exports